import React from 'react'
import './PhonereloadView.scss'

import CONFIG from '../../../../config'

import {getLanguageScope, C, N, DFS, capitalize, createLazyExecution} from '../../../../helpers'
const _i18n = getLanguageScope('phonereload');

import Amount from '../../shared/Amounts/containers/AmountContainer'
import Navigation from '../../shared/Navigation/containers/NavigationContainer'

import {Grid, Header, Form, Input, Dropdown} from 'semantic-ui-react'
import {validator} from "../../Phonereload/models/transaction";

class Phonereload extends React.Component {
  constructor(props){
    super(props);

    this.lazyUpdateAmounts = createLazyExecution(async function (product, amount) {
      await props.appSetServerVal('product', product);
      await props.appSetServerVal('original_amount', N(amount));
      await props.appCall('updateAmounts')
    }, 555)

  }

  updateAmount(product) {
    const {appSetVal, customer_limit_amount, denominations} = this.props;

    const productItem = _.find(denominations, (d) => d.value === product);

    if (customer_limit_amount && N(productItem.amount) > customer_limit_amount) return;

    appSetVal('display_amount', N(productItem.amount));

    this.lazyUpdateAmounts(product, productItem.amount)
  }

  componentDidUpdate(nextProps){
    const {appSetVal, account} = this.props;

    if(nextProps.phone_number && account !== nextProps.phone_number){
      appSetVal('phone_number', nextProps.phone_number);
      appSetVal('number', nextProps.phone_number);
      appSetVal('account', nextProps.phone_number);
    }
  }

  render(){

    const {submitTransaction, ready_to_submit, checkFields, title, icon, denominations, phone_error_type} = this.props;

    return (
      <Grid columns='equal'>
        <Grid.Row divided style={{'minHeight': 250}} stretched columns={2}>

          <Grid.Column>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Header image={`${CONFIG.STATIC_PATH}${icon}`} content={title} as='h3'/>
              </Grid.Column>

              <Grid.Column>
                <Form className='mt-30 mb-30'>
                  <Form.Field required>
                    <Header as='label' floated='left'>
                      {_i18n('enter_amount')}
                    </Header>

                    <Dropdown
                      search
                      selection
                      onChange={(e, {name, value}) => this.updateAmount(value)}
                      options={denominations}
                      placeholder={_i18n('select_amount')}
                    />

                  </Form.Field>
                </Form>

              </Grid.Column>
            </Grid.Row>
          </Grid.Column>

          <Grid.Column>
            <Grid.Row columns={1}>
              <Grid.Column>
                <Amount hideAmountInput={true} />
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>

        </Grid.Row>

        <Navigation
          onSubmit={submitTransaction}
          showSubmit={true}
          disabledSubmit={ready_to_submit}
          submitValidator={() => checkFields(validator)}
          showError={phone_error_type}
          messageError={phone_error_type ? _i18n(phone_error_type) : _i18n('invalid_number')}
        />

      </Grid>
    )
  }
}

export default Phonereload


// WEBPACK FOOTER //
// ./src/components/Applications/Phonereload/components/PhonereloadView.js